module.exports = __webpack_public_path__ + "static/media/won-sign.12437b6e.svg";